// src/components/Performance/PerformanceNotes.tsx

import React, { useEffect, useState } from "react";
import { Button, Tooltip } from "antd";
import { TableIcon } from "lucide-react";
import TimelineView from "./TimelineView";
import TableView from "./PerformanceTable";
import { useGetApiRequests } from "../../../../../../common/CommonExport";
import "./performanceNotes.scss";
import AddNoteModal from "./AddNoteModal";
import { useSelector } from "react-redux";
interface PerformanceNotesProps {
  currentUserId: string;

}


const PerformanceNotes: React.FC<Readonly<PerformanceNotesProps>> = ({ currentUserId }) => {
  const [view, setView] = useState<"timeline" | "table">("timeline");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [performanceNotes, setPerformanceNotes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const statusName = useSelector(
    (state: any) => state?.eventData?.particularEmployeeDetails?.status?.name
  );

  const pastStatuses = ["Resigned", "Layoff", "Termination", "Others"];
  const pastEmployee = pastStatuses.includes(statusName);



  const fetchPerformanceNotesApi = useGetApiRequests("getPerformanceNotes", "GET");

  const fetchPerformanceNotes = async () => {
    try {
      setLoading(true);
      const res = await fetchPerformanceNotesApi(null, {}, { employeeId: currentUserId });
      const data = (res as any)?.data?.data || [];

      setPerformanceNotes(Array.isArray(data) ? data : []);


    } catch (error) {
      setPerformanceNotes([]);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  useEffect(() => {
    fetchPerformanceNotes();
  }, []);

  return (
    <div className="performanceNotes">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold text-[#595959]">Performance Notes</h1>
          <p className="text-[#595959]/70 mt-2 text-sm">
            Track and manage employee performance feedback.
          </p>
        </div>
        <div className="flex items-center space-x-4">
          {!pastEmployee && <Tooltip placement="bottom" title="Add Performance Note">
            <Button
              type="primary"
              shape="circle"
              size="large"
              onClick={() => setIsModalOpen(true)}
            >
              <span className="material-symbols-outlined">add</span>
            </Button>
          </Tooltip>}

          <div className="flex items-center space-x-2 bg-white rounded-lg p-1 shadow-sm border border-gray-200">
            <button
              onClick={() => setView("timeline")}
              className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium button-tab__font--rubik transition-all ${view === "timeline"
                ? "bg-[#d34a7c] text-white shadow-sm"
                : "text-[#595959] hover:bg-[#d34a7c]/10 hover:text-[#d34a7c]"
                }`}
            >
              <span>Timeline</span>
            </button>
            <button
              onClick={() => setView("table")}
              className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium button-tab__font--rubik transition-all ${view === "table"
                ? "bg-[#d34a7c] text-white shadow-sm"
                : "text-[#595959] hover:bg-[#d34a7c]/10 hover:text-[#d34a7c]"
                }`}
            >
              <TableIcon className="w-4 h-4" />
              <span>Table</span>
            </button>
          </div>
        </div>
      </div>

      <div className="mt-6 flex flex-col h-[calc(100vh-300px)] overflow-y-scroll">
        {view === "timeline" ? (
          <TimelineView
            performanceData={performanceNotes}
            loading={loading}
            refreshData={fetchPerformanceNotes}
            pastEmployee={pastEmployee}
          />
        ) : (
          <TableView
            performanceData={performanceNotes}
            loading={loading}
            refreshData={fetchPerformanceNotes}
            pastEmployee={pastEmployee}
          />
        )}
      </div>



      <AddNoteModal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        employeeId={Number(currentUserId)}
        refreshData={fetchPerformanceNotes}
      />
    </div>
  );
};

export default PerformanceNotes;